import React, { useEffect, useState } from 'react';
import MyEditor from './MyEditor';
import { CreateAPI, GetEntryAPI } from '../../services';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import { DateFormat } from '../utils';
import HTMLCode from './HTMLCode';

const Comment = ({ editor }) => {
	const preferences = useSelector((state) => state.preferences);	
	const language = LanguageLoader(preferences.language);
	const current_user = useSelector((state) => state.current_user);
	const [content, SetContent] = useState('');
	const [list, SetList] = useState([]);
	const [ready, SetReady] = useState(false);
	const {module, id} = useParams();

	useEffect(() =>
	{
		SetReady(false);
		SetList([]);
		GetComments();
	// eslint-disable-next-line
	}, [id]);
	

	const GetComments = async () =>
	{
		try
		{
			if (id)
			{
				const data = {
					selected_fields: ['created_by', 'assigned_user_id', 'assigned_user_name', 'date_entered', 'description'],
					module : 'Comments',
					query :'`comments`.`record` = "'+ id +'" AND `comments`.`parent_module`="'+module+'"',
					order_by: '`date_entered` DESC',
				};
				const APIResponse = await GetEntryAPI(data);
				if (APIResponse)
				{
					SetList(APIResponse);
				}
				else
				{
					SetList([]);
				}
			}
		}
		catch (ex){}
		finally
		{
			SetReady(true);
		}
	}

	const CommentSubmit = async () => 
	{
		try
		{
			let commentContent = content;
			if(content.indexOf('<img') !== -1 && content.indexOf('src="') !== -1 && content.indexOf('data-location="') !== -1)
			{
				let fileURL = content.match(/data-location="[^ ]*"/)[0];
				if(fileURL && fileURL && fileURL.indexOf('data-location="') !== -1)
				{
					fileURL = fileURL.replace('data-location="', '').replace('"', '');
					const fileID = fileURL.split('id=')[1];
					fileURL = 'index.php?entryPoint=download&id='+fileID;
				}
				commentContent = content.replace(/data-mce-src="[^ ]*" /, '').replace(/data-location="[^ ]*"/, '').replace(/src="[^ ]*" /, 'src="'+fileURL+'" ');
			}
			const data = { record: id, parent_module: module, description: commentContent };
			const APIResponse = await CreateAPI(data,'Comments');
			if (APIResponse)
			{
				GetComments();
				SetContent(''); 
			}
		}
		catch (ex){console.log(ex);}
	};

	const hasComments = Boolean(list && list.length);
	if(!editor && (!ready || !hasComments))
	{
		return null;
	}

	return (
		<div className='wrapper'>
			<div className='title'>
				<h6>{language['COMMENTS']}</h6>
			</div>
			{editor ? <MyEditor initialContent={content} onSubmit={CommentSubmit} onCommentChange={(e) => SetContent(e)} /> : null}
			{list && list.length ?
			<div className="py-4 HTML_code comments">
				{list.map((comment, index) => 
					<div className="mb-4 py-4 px-3 border rounded-lg border-primaryBorder" key={index}>
						<div className="flex items-center justify-between">
							<div className="flex items-center">
								<i className="fa fa-user-circle text-4xl pl-4 pr-4"></i>
								<p className="font-semibold text-sm">
									{comment.assigned_user_id === current_user.id ? current_user.full_name : comment.assigned_user_name}
								</p>
							</div>
							<div className="flex items-center text-sm">
								<span>{DateFormat(comment.date_entered)}</span>
								<i className="fa fa-history pr-1"></i> 
							</div>
						</div>
						<HTMLCode innerHtml={comment.description} className={"mt-4 mx-5 text-xs"}/>
					</div>
				)}
			</div>
			: null}
		</div>
	);
};

export default Comment;
